import React from "react";

export default function BusAndStopGraphic() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="793.408"
            version="1.1"
            viewBox="0 0 743.82 146.393"
            preserveAspectRatio="xMidYMid meet"
            style={{
                maxHeight: '100px'
            }}
        >
            <defs>
                <pattern
                    id="pattern13992"
                    patternTransform="matrix(13.4399 0 0 7.46662 1509.626 244.654)"
                    xlinkHref="#Strips1_2white"
                ></pattern>
                <pattern
                    id="Strips1_2white"
                    width="3"
                    height="1"
                    patternTransform="scale(10)"
                    patternUnits="userSpaceOnUse"
                >
                    <path fill="#fff" stroke="none" d="M0 -0.5H1V1.5H0z"></path>
                </pattern>
                <clipPath id="clipPath4632-62-1" clipPathUnits="userSpaceOnUse">
                    <path
                        fill="green"
                        fillOpacity="0.52"
                        fillRule="evenodd"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="3.75"
                        d="M667.524 310.013l134.883-20.676v308.164L150.636 566.98c219.554-55.135 399.727-180.172 516.888-256.967z"
                        opacity="1"
                    ></path>
                </clipPath>
                <clipPath id="clipPath4684-0-9" clipPathUnits="userSpaceOnUse">
                    <path
                        fill="#00f"
                        fillOpacity="0.996"
                        fillRule="evenodd"
                        stroke="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeOpacity="1"
                        strokeWidth="1"
                        d="M128.976 545.32c203.145-68.262 339.34-153.262 444.031-222.508h34.46C504.416 398.95 351.155 494.78 129.96 563.042l-.984-17.722z"
                    ></path>
                </clipPath>
                <clipPath id="clipPath6110-21-5" clipPathUnits="userSpaceOnUse">
                    <path
                        fill="#f95"
                        fillOpacity="1"
                        fillRule="evenodd"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="1.5"
                        d="M-156.25 292.987H819.792V379.44500000000005H-156.25z"
                        opacity="1"
                    ></path>
                </clipPath>
                <clipPath id="clipPath4632-6-5-3-3-36" clipPathUnits="userSpaceOnUse">
                    <path
                        fill="green"
                        fillOpacity="0.52"
                        fillRule="evenodd"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="3.75"
                        d="M667.524 310.013l134.883-20.676v308.164L150.636 566.98c219.554-55.135 399.727-180.172 516.888-256.967z"
                        opacity="1"
                    ></path>
                </clipPath>
                <clipPath id="clipPath4684-78-8-4-8-35" clipPathUnits="userSpaceOnUse">
                    <path
                        fill="#00f"
                        fillOpacity="0.996"
                        fillRule="evenodd"
                        stroke="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeOpacity="1"
                        strokeWidth="1"
                        d="M128.976 545.32c203.145-68.262 339.34-153.262 444.031-222.508h34.46C504.416 398.95 351.155 494.78 129.96 563.042l-.984-17.722z"
                    ></path>
                </clipPath>
                <clipPath id="clipPath6110-2-5-1-3-91" clipPathUnits="userSpaceOnUse">
                    <path
                        fill="#f95"
                        fillOpacity="1"
                        fillRule="evenodd"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="1.5"
                        d="M-156.25 292.987H819.792V379.44500000000005H-156.25z"
                        opacity="1"
                    ></path>
                </clipPath>
                <clipPath id="clipPath9424" clipPathUnits="userSpaceOnUse">
                    <path
                        fill="#2c5aa0"
                        fillOpacity="1"
                        fillRule="evenodd"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="5"
                        d="M-4098.751 790.901H-3354.931V1088.654H-4098.751z"
                        opacity="0.75"
                    ></path>
                </clipPath>
            </defs>
            <g display="inline" transform="translate(4098.75 -878.567)">
                <g
                    fillRule="evenodd"
                    strokeOpacity="1"
                    display="none"
                    transform="translate(211.47 314.875)"
                >
                    <path
                        fill="#b4c0c9"
                        fillOpacity="1"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeWidth="3.75"
                        d="M88.232 264.035a45.735 31.793 0 00-45.398 28.123h-.797v35.25h41.129a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zm463.575 0a45.735 31.793 0 00-45.399 28.123h-.797v35.25h41.13a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zM92.87 88.746H750.96c17.448 0 31.496 14.048 31.496 31.496v175.535c0 17.448-14.048 31.494-31.496 31.494H108.141l-.006.348H-74.197l-40.518-6.873.795-74.57 43.695-112.371 1.174-.19C-24.05 92.054 67.522 87.988 90.684 88.844l-.01.265a6.857 6.857 0 012.197-.363z"
                        display="inline"
                        opacity="1"
                    ></path>
                    <path
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeWidth="3.75"
                        d="M127.792 308.897a39.41 39.41 0 01-39.41 39.41 39.41 39.41 0 01-39.41-39.41 39.41 39.41 0 0139.41-39.41 39.41 39.41 0 0139.41 39.41z"
                        display="inline"
                        opacity="1"
                    ></path>
                    <path
                        fill="#333"
                        fillOpacity="0.996"
                        stroke="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeWidth="1"
                        d="M-71.575 159.83v82.227h-31.953z"
                        display="inline"
                    ></path>
                    <path
                        fill="#e90020"
                        fillOpacity="1"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeWidth="3.75"
                        d="M88.232 500.035a45.735 31.793 0 00-45.398 28.123h-.797v35.25h41.129a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zm463.575 0a45.735 31.793 0 00-45.399 28.123h-.797v35.25h41.13a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zM92.87 324.746H750.96c17.448 0 31.496 14.048 31.496 31.496v175.535c0 17.448-14.048 31.494-31.496 31.494H108.141l-.006.348H-74.197l-40.518-6.873.795-74.57 43.695-112.371 1.174-.19c45.001-41.561 136.573-45.627 159.735-44.771l-.01.265a6.857 6.857 0 012.197-.363z"
                        clipPath="url(#clipPath4632-62-1)"
                        display="inline"
                        opacity="1"
                        transform="translate(0 -236)"
                    ></path>
                    <path
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeWidth="3.75"
                        d="M591.217 308.897a39.41 39.41 0 01-39.41 39.41 39.41 39.41 0 01-39.41-39.41 39.41 39.41 0 0139.41-39.41 39.41 39.41 0 0139.41 39.41z"
                        display="inline"
                        opacity="1"
                    ></path>
                    <path
                        fill="#0049a8"
                        fillOpacity="1"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeWidth="3.75"
                        d="M88.232 500.035a45.735 31.793 0 00-45.398 28.123h-.797v35.25h41.129a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zm463.575 0a45.735 31.793 0 00-45.399 28.123h-.797v35.25h41.13a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zM92.87 324.746H750.96c17.448 0 31.496 14.048 31.496 31.496v175.535c0 17.448-14.048 31.494-31.496 31.494H108.141l-.006.348H-74.197l-40.518-6.873.795-74.57 43.695-112.371 1.174-.19c45.001-41.561 136.573-45.627 159.735-44.771l-.01.265a6.857 6.857 0 012.197-.363z"
                        clipPath="url(#clipPath4684-0-9)"
                        display="inline"
                        opacity="1"
                        transform="translate(-.03 -235.711)"
                    ></path>
                    <path
                        fill="#333"
                        fillOpacity="1"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeWidth="3.75"
                        d="M-60.417 151.432H689.583V242.057H-60.417z"
                        display="inline"
                        opacity="1"
                    ></path>
                    <path
                        fill="#999"
                        fillOpacity="1"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeWidth="3.75"
                        d="M113.431 308.897a25.05 25.05 0 01-25.05 25.05 25.05 25.05 0 01-25.048-25.05 25.05 25.05 0 0125.049-25.05 25.05 25.05 0 0125.05 25.05z"
                        display="inline"
                        opacity="1"
                    ></path>
                    <path
                        fill="#999"
                        fillOpacity="1"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeWidth="3.75"
                        d="M576.856 308.897a25.05 25.05 0 01-25.049 25.05 25.05 25.05 0 01-25.049-25.05 25.05 25.05 0 0125.05-25.05 25.05 25.05 0 0125.048 25.05z"
                        display="inline"
                        opacity="1"
                    ></path>
                    <path
                        fill="#000"
                        fillOpacity="0.258"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeWidth="3.75"
                        d="M88.232 264.035a45.735 31.793 0 00-45.398 28.123h-.797v35.25h41.129a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zm463.575 0a45.735 31.793 0 00-45.399 28.123h-.797v35.25h41.13a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zM92.87 88.746H750.96c17.448 0 31.496 14.048 31.496 31.496v175.535c0 17.448-14.048 31.494-31.496 31.494H108.141l-.006.348H-74.197l-40.518-6.873.795-74.57 43.695-112.371 1.174-.19C-24.05 92.054 67.522 87.988 90.684 88.844l-.01.265a6.857 6.857 0 012.197-.363z"
                        clipPath="url(#clipPath6110-21-5)"
                        display="inline"
                        opacity="1"
                    ></path>
                    <path
                        fill="#000"
                        fillOpacity="0.996"
                        stroke="#b1b1b1"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="4"
                        strokeWidth="2"
                        d="M652.294 251.225H743.12V309.941H652.294z"
                        opacity="1"
                    ></path>
                    <path
                        fill="none"
                        stroke="#b1b1b1"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeWidth="2"
                        d="M652.423 308.86l90.223-56.954z"
                    ></path>
                    <path
                        fill="none"
                        stroke="#b1b1b1"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeWidth="2"
                        d="M742.818 309.059l-90.223-56.953z"
                        display="inline"
                    ></path>
                </g>
                <image
                    width="22"
                    height="22"
                    x="-3790.407"
                    y="1022.22"
                    display="none"
                    preserveAspectRatio="none"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAABHNCSVQICAgIfAhkiAAAIABJREFU eJzt3XuQnXd93/HP7zm7knfPrmxJOAFiLBtLCWAuTmRJxrp4dbGpZ2CalHFiQkjShkwgXJq2KRkm kDGd6SWQTKldSJqmaQspNNGUgUDwWF5p10bC3pUEMRffZLAtGwewLQnvDUt7zq9/SEespLNnz+V5 nt/v+zzv11/W7kr+MXj2897fc3YlAQCA0nGhD5A1PzLSN9M/81rv9bNJ3a3zTuucd2u98yslDcrp YnkNSapJmvXSCSc/I++OeacjTjrinX9Mqjw0NHr/w07ygf8nAQCa8JKb3nXdq6Taq513a720znmt k/OrvFzVSZdIGpCUyGnWex13XrNO7kenP9/7I3WvI87r0epL1nzL7d5dC/2/KUuFCwB/yy2Vqece vy5JKtskv03SZknDKf3xz3lpv/PuHpfU7qmOHvp6Sn8uAKBDXnKzO677eZ/Ub/BeNzhpi6TVKf3x U5LbL1e/t17XvcOrr5goWhAUJgCmtm+42iXuHZJ+XdLLcvrXHpXc5513/7u67/6v5fTvBIBSm9q5 6TVy/ped169KWpfTv/Z5L///vEs+PTw6caAIt8GmA+DZzZuHBy469dvO6d3ea23g4zzgpDsGV01/ 2u1+8GTgswBAofib1y6fPbnq17z0PklvCHycI/Luk7P1gb/8qfHx6cBn6ZrJAJi6+ecv1an+9ziv 90laFfo85/mBd/rz+fmTH185/g8nQh8GACw7/YXe/L+Q/O9Luiz0ec7zguT+l0v6/rh694FnQh+m U6YCwL9l/eD0TN8HnfP/RqdfyBGzE5K7rVob+IQbH58PfRgAsMSvX98/s7LyXnn9kU6/eC9mc17+ Y0OD9T92Xzw8G/ow7TITADM7NrzFO3e7pCtCn6VDj8jpXw6NTt4V+iAAYMHUrutGnK/dLrnXhT5L h56W0x8OjU5+KvRB2hF9AMyObLqsXqn/leRuDH2Wnjh99tT8yd/lsQAANHdiy5aVfctf/KTkbg19 lh7dlfjKbw3uu+97oQ/SStQBML1z042S/7Sknw59lpQ8VXfuV1eMTuwPfRAAiMnsjms31lzyWSe9 MvRZUvKck/55de/kl0IfZDFRBoBfv75/emXlD53XhyUloc+Tsnnv9O+Htkz+O3eb6qEPAwAhecnN 7Nz0fsl/TFJ/6POkzEvujuqqqX8b43eHRRcAp6+ATn5B0tbQZ8mS8+5zg/WBt7vx8R+HPgsAhOBH Ri6arsx+1km/GPosGbv3VO3kP43tEXBUATDzpvUv8/OVL0u6JvRZcuF1z6n6yV+M7T8KAMja8ZFr LumvLPuCpG2hz5KTbyc1908GxyeeDn2QhmgC4MSO9Vf1u8pdXroq9FlyFt1/FACQpdJ9sfcTT9br 9TetGDv0SOiDSJEEwPTOTa+X96NyujT0WQJ5vOJqIwOjh4+GPggAZGlux/Vram5+TNKVoc8ShNez Sio7h0bv+2boowQPgOmdm14v+b2SXhL6LIEdrVQ0MrBn8vHQBwGALMztWn/5vK+MFeiV/t2JJAKC BgDjfwEiAEAhMf7niSACggUA478oIgBAoTD+iwgcAUG+x356+8Y3MP6LurxW0/jcTRvL+XwMQKEw /i04Xap6be/0rjcG+ZHHud8ATG/f+AYlGhXjvxRuAgCYxvi3KdBNQK4BwPh3jAgAYBLj36EAEZBb ADD+XSMCAJjC+Hcp5wjIJQAY/54RAQBMYPx7lGMEZB4AjH9qiAAAUWP8U5JTBGQaAIx/6ogAAFFi /FOWQwRkFgCMf2aIAABRYfwzknEEZPJzAKZv3HAN458Zfk4AgGgw/hnK+OcEpH4DMH3jhmtUd6OS Vqf9Z+Mc3AQACIrxz0lGNwGpBgDjnzsiAEAQjH/OMoiA1AKA8Q+GCACQK8Y/kJQjIJUAYPyDIwIA 5ILxDyzFCOg5ABj/aBABADLF+EcipQjoKQAY/+gQAQAywfhHJoUI6DoAGP9oEQEAUsX4R6rHCOgq ABj/6BEBAFLB+EeuhwjoOACmbrr2ta6W3CNpVae/F7l6vOJqIwOjh4+GPggAm+Z2XL+m5ubHJPGD x2Lm9Wzd17euGDv0SCe/raMAmB3ZdFm94g9IuryjwyEUbgIAdIWv/M15Oqn46wf3HHyq3d/Q9o8C fmHnxtX1it8jxt8SfmwwgI4x/iZdVp93Xz6xZcvKdn9DWwHgR0YuctKXJL2666MhlMtrNe2d27We cAOwpLkd16+p+co442+Q02v7lp/8vL/lNcva+fC2AmC2MvMnTrqut5MhoCtrvvIVbgIAtDK3a/3l 825+n3jmb9m2mWND/7GdD1zyNQAzOze+2Ut/187HInq8JgBAU1z7F4p3zv1SdXTiC60+qOWon3nR 3z+Ib/crEiIAwDkY/wJyOl5R7ZpW3wnW8hFAveI/Jca/aHhNAICzeOZfUF4raz75y1YfsmgATO3c dKuk7akfCjHgNQEAeOZfeO7GqV2b3rroe5u90b9l/eDMbOVBSWsyOxdiwOMAoKS49i+Np6qVH7/a 7fnGzPnvaHoDMDObfEiMfxnwcwKAEmL8S+UV07XlH2j2jgtuAKZHNrxUFfe4pIsyPxZiwY8NBkqC H+9bSnO+0nfF8J6v/nDhGy+8Aai43xPjXza8JgAoAZ75l9aA5mvvO/+N59wAPLt58/DARaeOSrok t2MhJrwmACgorv1Lzun43Fz/mksPHJhqvOmcG4CBgVPvEuNfZrwmACggxh/yWjkwcOqdC9+U/OR9 ct7rXfmfCpHh5wQABcL3+aPBSb+78NdnA2Bqx4Y38h8IzuA1AUAB8MwfC3mvtbM7rt3Y+PXZAKgk 7m1hjoRI8TgAMIxrfzRTX7D1iST5W26peK9bwh0JkSICAIMYfyzKu1/xt9xSkc4EwNTxo2+U9NNB D4VY8ZoAwBCe+WMJL5s79uRG6UwAVFQfCXocxI7XBAAG8Mwf7ag7f4PUeAQgtzXscWAAjwOAiHHt j7b5ZJskOT8y0jdTmT0maTjwkWADPywIiAzjjw5NVWuDq5LZvunXifFH+3hNABARnvmjC8Mzbvbq pO4rPxf6JDCH1wQAEeCZP7rlnX42SVRfF/ogMInXBAABce2PXiRO6xLvHAGAbhEBQACMP3rl5dYl 3uuq0AeBabwmAMgRz/yRBie/NnHSytAHgXm8JgDIAc/8kRbvdUkiaSj0QVAIPA4AMsS1P1LlNJzI EQBIDREAZIDxRwaGEnkCAKniNQFAinjmj4wMJ5J86FOgcHhNAJACnvkjQ/VE0nToU6CQeBwA9IBr f2TKayqRNBX6HCgsIgDoAuOPzDlNcwOArBEBQAcYf+TDTyfyei70MVB4vDAQaAMv+EOOnk/k9Fjo U6AUeGEg0AIv+EOevE+OJPI6EvogKA0eBwBNcO2PvLnEH0l84gkA5IkIABZg/BFCUtdjiXzycOiD oHR4TQAgnvkjnFqSPOy85GZ2bnxW0urQB0LpHK1UNDKwZ/Lx0AcB8sZX/gjoWHXr5KWJk7yX9oc+ DUqJxwEoJcYfIXnpHnfb6Z8EKCfdG/pAKC0iAKXC+CM05929knQ6AFx9LOxxUHK8JgClwDN/RKFS H5ck1/j19M6Nj0paF+o8gHhNAAqMr/wRAyd9Z3Dv5Don+aTxRu/0tyEPBYjHASgoxh+xqMt9xp35 W4CTn7w5+T+hDgQsQASgUBh/RKVe/5vGP54NgOHR+x+S9ECQAwHn4jUBKASe+SMyDwyPHfx24xfJ wvc4527P/zxAU/zdATCNn+2P2Jy/8ecEwODx+U9LeirXEwGL43EATOLaHxH63uDKqb9e+IZzbwAO Hz4lzy0AokIEwBTGH1Hy7uNu94MnF74pOf9jXlyuv5DT8fxOBSyJ1wTABJ75I0pOx19crr84/80X BMDqOydekHcfyedUQNt4TQCixjN/RMu7j6y+c+KF8998QQBIUnXV5f9V0jcyPxTQGR4HIEpc+yNi D1ZPzH+y2TuaBoDbvbtWd+49OvPDAoCIEAGICuOPqHn3r9zhw6eavatpAEjSitGJ/ZI+k9mhgO7x mgBEgWf+iJv/v0P7JvYs9t5FA0CSTrraeyTxc9kRI14TgKB45o/IPVXr63tPqw9oGQCrRg//yMn/ iqSTrT4OCITHAQiCa39Ebr5er7/t4rvuO9bqg1oGgCRV9x48KOnDqR0LSBcRgFwx/oie8x9eMXbo wFIftmQASFJ17+TH5PnbAhEtXhOAXPDMH7Fz3n2uuuXgR9v52LYCwEm+unr6HXJa9MUEQGC8JgCZ 4pk/DLh3sD7wdneb6u18sOvkT3528+bhgYtOjkvuF7o6GpC9o5WKRgb2TPLiVaSGa39Ez+tb8yeX bbtk//62f5JvRwEgSdMjG17q+txXvNfaTn8vkJPHK642MjB6+Gjog8C+uR3Xr6m5+THxlT/i9bhL +rdU7z7wTCe/qa1HAAsNjR/8vpt3253TY53+XiAnPA5AKrj2hwFHKxXt7HT8pS5uABpmRzZd5vv8 GDcBiBiPA9A1rv1hQE+f47oOAIkIgAlEADrG+MOAnj+39RQAEhEAE4gAtI3xhwGpfE7rOQAkIgAm EAFYEuMPA1L7XJZKAEhEAEwgArAoxh8GpPo5LLUAkIgAmEAE4AKMPwxI/XNXqgEgEQEwgQjAWYw/ DMjkc1bqASARATCBCADjDwsy+1yVSQBIRABMIAJKjPGHAZl+jsosACQiACYQASXE+MOAzD83ZRoA EhEAE4iAEmH8YUAun5MyDwCJCIAJREAJMP4wILfPRR3/ZUDdGByfeJq/QAiRu7xW0zh/gVBxMf4w 4Mk8vxDJ5QaggZsAGMBNQAEx/jDgyUpF2/P83JNrAEhEAEwgAgqE8YcBuY+/FCAAJCIAJhABBcD4 w4Ag4y8FCgCJCIAJRIBhjD8MCDb+UsAAkIgAmEAEGMT4w4Cg4y8FDgCJCIAJRIAhjD8MCD7+UgQB IBEBMIEIMIDxhwFRjL8USQBIRABMIAIixvjDgGjGX4ooACQiACYQARFi/GFAVOMvRRYAEhEAE4iA iDD+MCC68ZciDACJCIAJREAEGH8YEOX4S5EGgEQEwAQiICDGHwZEO/5SxAEgEQEwgQgIgPGHAVGP vxR5AEhEAEwgAnLE+MOA6MdfMhAAEhEAE4iAHDD+MMDE+EtGAkAiAmACEZAhxh8GmBl/yVAASEQA TCACMsD4wwBT4y8ZCwCJCIAJRECKGH8YYG78JYMBIBEBMIEISAHjDwNMjr9kNAAkIgAmEAE9YPxh gNnxlwwHgEQEwAQioAuMPwwwPf6S8QCQiACYQAR0gPGHAebHXypAAEhEAEwgAtrA+MOAQoy/VJAA kIgAmEAEtMD4w4DCjL9UoACQiACYQAQ0wfjDgEKNv1SwAJCIAJhABCzA+MOAwo2/VMAAkIgAmEAE iPGHCYUcf6mgASARATCh1BHA+MOAwo6/VOAAkIgAmFDKCGD8YUChx18qeABIRABMKFUEMP4woPDj L5UgACQiACaUIgIYfxhQivGXShIAEhEAEwodAYw/DCjN+EslCgCJCIAJhYwAxh8GlGr8pZIFgEQE wIRCRQDjDwNKN/5SCQNAIgJgQiEigPGHAaUcf6mkASARATDBdAQw/jCgtOMvlTgAJCIAJpiMAMYf BpR6/KWSB4BEBMAEUxHA+MOA0o+/RABIIgJggokIYPxhAON/BgFwBhEAA6KOAMYfBjD+CxAACxAB MCDKCGD8YQDjfx4C4DxEAAyIKgIYfxjA+DdBADRBBMCAKCKA8YcBjP8iCIBFEAEwIGgEMP4wgPFv gQBogQiAAUEigPGHAYz/EgiAJRABMCDXCGD8YQDj3wYCoA1EAAzIJQIYfxjA+LeJAGgTEQADMo0A xh8GMP4dIAA6QATAgEwigPGHAYx/hwiADhEBMCDVCGD8YQDj3wUCoAtEAAxIJQIYfxjA+HeJAOgS EQADeooAxh8GMP49IAB6QATAgK4igPGHAYx/jwiAHhEBMKCjCGD8YQDjnwICIAVEAAxoKwIYfxjA +KeEAEgJEQADWkYA4w8DGP8UEQApIgJgQNMIYPxhAOOfMgIgZUQADDgnAhh/GMD4Z4AAyAARAAOO VioaUb1WY/wRuScrtWRkYPz+J0IfpGgIgIwQAYiff0Zy85IuD30SYBGMf4YIgAwRAQDQNcY/YwRA xogAAOgY458DAiAHRAAAtI3xzwkBkBMiAACWxPjniADIEREAAIti/HNGAOSMCACACzD+ARAAARAB AHAW4x8IARAIEQAAjH9IBEBARACAEmP8AyMAAiMCAJQQ4x8BAiACRACAEmH8I0EARIIIAFACjH9E CICIEAEACozxjwwBEBkiAEABMf4RIgAiRAQAKBDGP1IEQKSIAAAFwPhHjACIGBEAwDDGP3IEQOSI AAAGMf4GEAAGEAEADGH8jSAAjCACABjA+BtCABhCBACIGONvDAFgDBEAIEKMv0EEgEFEAICIMP5G EQBGEQEAIsD4G0YAGEYEAAiI8TeOADCOCAAQAONfAARAARABAHLE+BcEAVAQRACAHDD+BUIAFAgR ACBDjH/BEAAFQwQAyADjX0AEQAERAQBSxPgXFAFQUEQAgBQw/gVGABQYEQCgB4x/wREABUcEAOgC 418CBEAJEAEAOsD4lwQBUBJEAIA2MP4lQgCUCBEAoAXGv2QIgJIhAgA0wfiXEAFQQkQAgAUY/5Ii AEqKCAAgxr/UCIASIwKAUmP8S44AKDkiACglxh8EAIgAoGQYf0giAHAGEQCUAuOPswgAnEUEAIXG +OMcBADOQQQAhcT44wIEAC5ABACFwvijKQIATREBQCEw/lgUAYBFEQGAaYw/WiIA0BIRAJjE+GNJ BACWRAQApjD+aAsBgLYQAYAJjD/aRgCgbUQAEDXGHx0hANARIgCIEuOPjiWhDwBbBscnnnbzbrtz eiz0WQBIkp5g/NENbgDQFW4CgCg8Uakl2xl/dIMAQNeIACAoxh89IQDQEyIACILxR88IAPSMCABy xfgjFQQAUkEEALlg/JEaAgCpIQKATDH+SBUBgFQRAUAmGH+kjgBA6ogAIFWMPzJBACATRACQCsYf mSEAkBkiAOgJ449MEQDIFBEAdIXxR+YIAGSOCAA6wvgjFwQAckEEAG1h/JEbAgC5IQKAlhh/5IoA QK6IAKApxh+5IwCQOyIAOAfjjyAIAARBBACSGH8ERAAgGCIAJcf4IygCAEERASgpxh/BEQAIjghA yTD+iAIBgCgQASgJxh/RIAAQDSIABcf4IyoEAKJCBKCgGH9EhwBAdIgAFAzjjygRAIgSEYCCYPwR LQIA0SICYBzjj6gRAIgaEQCjGH9EjwBA9IgAGMP4wwQCACbMjmy6zFf8V7x0ReizAC08XaklWxl/ WJCEPgDQlmV1JzmCFbFzp/9bBeJHACB6szdteIWvuTEvvyb0WYAl/EytprG5mzZeGfogwFIoVUTt J+Ovq0KfBejAk5WKtg/smXw89EGAxRAAiBbjD+OIAESNAECUGH8UBBGAaBEAiA7jj4IhAhAlAgBR YfxRUEQAokMAIBqMPwqOCEBUCABEgfFHSRABiAYBgOAYf5QMEYAoEAAIivFHSREBCI4AQDCMP0qO CEBQBACCYPwBSUQAAiIAkDvGHzgHEYAgCADkivEHmiICkDsCALlh/IGWiADkigBALhh/oC1EAHJD ACBzjD/QESIAuSAAkCnGH+gKEYDMEQDIDOMP9IQIQKYIAGSC8QdSQQQgMwQAUsf4A6kiApAJAgCp YvyBTBABSB0BgNQw/kCmiACkigBAKhh/IBdEAFJDAKBnjD+QKyIAqSAA0BPGHwiCCEDPCAB0jfEH giIC0BMCAF1h/IEoEAHoGgGAjjH+QFSIAHSFAEBHGH8gSkQAOkYAoG2MPxA1IgAdIQDQFsYfMIEI QNsIACyJ8QdMIQLQFgIALTH+gElEAJZEAGBRjD9gGhGAlggANMX4A4VABGBRBAAuwPgDhUIEoCkC AOdg/IFCIgJwAQIAZzH+QKERATgHAQBJjD9QEkQAziIAwPgD5UIEQBIBUHqMP1BKRAAIgDJj/IFS IwJKjgAoKcYfgIiAUiMASojxB7AAEVBSBEDJMP4AmiACSogAKBHGH0ALREDJEAAlwfgDaAMRUCIE QAkw/gA6QASUBAFQcIw/gC4QASVAABQY4w+gB0RAwREABcX4A0gBEVBgBEABMf4AUkQEFBQBUDCM P4AMEAEFRAAUCOMPIENEQMEQAAXB+APIARFQIARAATD+AHJEBBQEAWAc4w8gACKgAAgAwxh/AAER AcYRAEYx/gAiQAQYRgAYxPgDiAgRYBQBYAzjDyBCRIBBBIAhjD+AiBEBxhAARjD+AAwgAgwhAAxg /AEYQgQYQQBEjvEHYBARYAABEDHGH4BhREDkCIBIMf4ACoAIiBgBECHGH0CBEAGRIgAiw/gDKCAi IEIEQEQYfwAFRgREhgCIBOMPoASIgIgQABFg/AGUCBEQCQIgMMYfQAkRAREgAAJi/AGUGBEQGAEQ COMPAERASARAAIw/AJxFBARCAOSM8QeACxABARAAOWL8AWBRREDOCICcMP4AsCQiIEcEQA4YfwBo GxGQEwIgY4w/AHSMCMgBAZAhxh8AukYEZCwJfYCiYvwROyc97qQnQp8DWMSaWk1jczdtvDL0QYqK AMgA4w8Djjhf2epqbqtzeiz0YYBFEAEZ4hFAyhh/GHAk8ZXtg/vu+54kzY5susz3+THvtTb0wYBF 8DggAwRAihh/GHDO+DcQATCACEgZAZASxh8GNB3/BiIABhABKSIAUsD4w4CW499ABMAAIiAlBECP GH8Y0Nb4NxABMIAISAEB0APGHwZ0NP4NRAAMIAJ6RAB0ifGHAV2NfwMRAAOIgB4QAF1g/GFAT+Pf QATAACKgSwRAhxh/GJDK+DcQATCACOgCAdABxh8GpDr+DUQADCACOkQAtInxhwGZjH8DEQADiIAO EABtYPxhQKbj30AEwAAioE0EwBIYfxiQy/g3EAEwgAhoAwHQAuMPA3Id/wYiAAYQAUsgABbB+MOA IOPfQATAACKgBQKgCcYfBgQd/wYiAAYQAYsgAM7D+MOAKMa/gQiAAURAEwTAAow/DIhq/BuIABhA BJyHADiD8YcBUY5/AxEAA4iABQgAMf4wIerxbyACYAARcEbpA4DxhwEmxr+BCIABRIBKHgCMPwww Nf4NRAAMKH0ElDYAGH8YYHL8G4gAGFDqCChlADD+MMD0+DcQATCgtBFQugBg/GFAIca/gQiAAaWM gFIFAOMPAwo1/g1EAAwoXQSUJgAYfxhQyPFvIAJgQKkioBQBwPjDgEKPfwMRAANKEwGFDwDGHwaU YvwbiAAYUIoIKHQAMP4woFTj30AEwIDCR0BhA4DxhwGlHP8GIgAGFDoCChkAjD8MKPX4NxABMKCw EVC4AGD8YQDjvwARAAMKGQGFCgDGHwYw/k0QATCgcBFQmABg/GEA498CEQADChUBhQgAxh8GMP5t IAJgQGEiwHwAMP4wgPHvABEAAwoRAaYDgPGHAYx/F4gAGGA+AswGAOMPAxj/HhABMMB0BJgMAMYf BjD+KSACYIDZCDAXAIw/DGD8U0QEwACTEWAqABh/GMD4Z4AIgAHmIsBMADD+MIDxzxARAANMRYCJ AGD8YQDjnwMiAAaYiYDoA4DxhwGMf46IABhgIgKiDgDGHwYw/gEQATAg+giINgAYfxjA+AdEBMCA qCMgygBg/GEA4x8BIgAGRBsB0QUA4w8DGP+IEAEwIMoIiCoAGH8YwPhHiAiAAdFFQDQBwPjDAMY/ YkQADIgqAqIIAMYfBjD+BhABMCCaCAgeAIw/DGD8DSECYEAUERA0ABh/GMD4G0QEwIDgERAsABh/ GMD4G0YEwICgERAkABh/GMD4FwARAAOCRUCS97+Q8YcBjzL+xTA4PvG0m3fbndNjoc8CLGJNraax uZs2Xpn3vzjXAGD8YcCjLuln/AuECIABQSIgt0cAjD8MeNQl/durdx94JvRBkD4eB8CAXB8H5BIA jD8MYPxLgAiAAblFQOYBwPjDAMa/RIgAGJBLBGQaAIw/DGD8S4gIgAGZR0BmAcD4wwDGv8SIABiQ aQRkEgCMPwxg/EEEwILMIiD1AGD8YQDjj7OIABiQSQSkGgCMPwxg/HEBIgAGpB4BqQUA4w8DGH8s igiAAalGQCoBwPjDAMYfSyICYEBqEdBzADD+MIDxR9uIABiQSgT0FACMPwxg/NExIgAG9BwBXQcA 4w8DGH90jQiAAT1FQFcBwPjDAMYfPSMCYEDXEdBxAMzcuPnlvn5qv6Tc/+5ioE2PuKR/B+OPNBAB iJ2Xvpsk/Vs7/ZyXdPLBz9+8aYWvn/p7Mf6I16OMP9I0OD7xtJt3253TY6HPAjTjpFf62qm7TmzZ srKT39d2APiRkYuWn/RflHRNx6cD8sG1PzJBBCB6Tq/tW37y835k5KJ2f0tbAeBvUzJdmf2MpG1d Hw7I1iOMP7JEBMCAbbOVmb/2t7W37W190Oy9Gz/opF/q7VxAZrj2Ry6IAMTOy711Zv+GD7TzsUu+ CHB2x7Ub6y7ZL6m/55MB6ePaH7njhYGI3Hzd+xtW7Dv41VYf1DIAjo9cc0l/ZdnXJV2R5smAlDD+ CIYIQOSeqvVVrrn4rvuOLfYBLR8B9Ff6/0yMP+LEM38ExeMARO4VlVO1O1p9wKI3AFM7Nu5wTnvT PxPQM77yRzS4CUDMvNyO4b0TY83e1/QGwI+M9DnnP57tsYCuMP6ICjcBiJmTv8OvX9/0NXxNA2Cm Mvt+yb0u22MBHWP8ESUiABG7evqS5N3N3nHBI4Bju9ZfvMxXnpB0SdanAjrAj/dF9HgcgCg5HZ+b 619z6YEDUwvffMENwLJ65V1i/BEXvs8fJnATgCh5rRxYPv8757/5nBvWYFuuAAAJwUlEQVQAf/Pa 5TMnV35Xci/P72RAS1z7wxxuAhCh71VXTb/S7X7wZOMN59wAzJ5a+euMPyLC+MMkbgIQoZ+ZeX74 7QvfcE4AeO/em+95gEXxff4wjQhAdJx//zm/bPzD1M5Nr3Hy387/RMAF+MofhcHjAMTE1/1rh8cO fltacAPgVP+1cEcCzmL8USjcBCAqLrm18Y+JJHnJSe7WxX8HkAvGH4VEBCAWifNv82du/xNJmt2+ 6RckXRn0VCi7R1xfbYTxR1ERAYiBl66auXHDG6TGDUBSHwl6IpTd6e/zv+vwP4Y+CJAlIgBRqCc3 SI0AcNoW9jQoMa79USpEAEJz/vTmJ15yzrvNoQ+EUmL8UUpEAELyzm/zknN8+x8CecT11bZz7Y8y 41sEEUq9Unt1IqdXhz4ISodn/oC4CUA4lVrlVYlTfV3og6BUuPYHFiACEIL3bm0i7wgA5IXxB5og ApA37+rrEolnT8gF3+cPtEAEIE9Obl0iaXXog6DweOYPtIEIQI5WJ5KGQp8Chca1P9ABIgB58NJQ Imk49EFQWIw/0AUiAFlzZwKAGwBkgfEHekAEIGPDic78rUBAinjBH5ACIgAZShI5TYc+BQqFF/wB KSICkJGpRJ4AQGq49gcyQAQgA1OJRAAgFYw/kCEiAOny04nz7ljoY8A8nvkDOSACkBrvjiU+8d8N fQ6YxjN/IEdEAFLh9J3EeX8k9DlgFtf+QABEAHrm/JGkroQAQDcYfyAgIgC98EqOJC6pPxz6IDDG u4d55g+ERwSga0ntkaR6qvotSVOhzwIzHnWVvp088wfiQASgCz8auvjKhxI3Pj4v6auhTwMTuPYH IkQEoENfcbt31xJJctK9oU+D6DH+QMSIALTNnd78RJJq9fo9YU+DqPHMHzCBCEA7kjObn0jS8A2H 7pM8n9zRDM/8AUOIALTmnxnYduiQdCYA3G2qS9od9EyIEdf+gEFEABbl9Jkzm386ACQpqVc+G+5E iBDjDxhGBKAZt2DrXeMfvORmd2484qWrwhwL0fDuYdc/z4/3BQpgdmTTZb7Pj3mvtaHPguAeHdo7 +XONX5y9AXCS9/J/FuZMiAjP/IEC4SYADV7+Ewt/nSz8RbXy4p9Lej7XEyEmXPsDBUQEQNLzc7Xq Xy18wzkB4PZ8Y8ZL/y3fMyESjD9QYERAuTm5239qfHx64duSZh8kaS63UyE8vs8fKAUioLRmaudd /0tNAmBo78QPvHd/ms+ZEAGe+QMlQgSUj3P+P63YO3nB4/0LAkCShuaS/yDpiawPheC49gdKiAgo Dy99d3C++ifN3tc0ANx99815rw9keywExvgDJUYElEPi/e+58fEfN3ufa/bGhumdm+6W/K5sjoVg +D5/AGfwcwIK7e+H9k6+ebF3Nr0BOPtOn/ympOfSPhGC4pk/gLO4CSisH7q+2m+3+oCWATC4777v ubr7DUk+1WMhFK79AVyACCicurx7x1Jf6LUMAEmqjk18WfK3p3cuBML4A1gUEVAg3n10aN/EnqU+ bMkAkKTqsuN/4KT9vZ8KQfB9/gDaQAQUwr7qj+b/qJ0PbCsA3J2Pvfiiq71Z0gM9HQsh8MwfQNuI AMv8N0/VTr7VHT58qp2PbvldAOebuXHzy3391FclrenqbMgb1/4AusJ3B9jipe+6mt88NH7w++3+ nrZuABqqdx94xrvkZvGdAfHj2h9AD7gJMOUH9VrlTZ2Mv9RhAEjS8Oj9D6muXSICYsa1P4CeEQEm /NBX6rsuHr+v4/+POnoEsND09o1vUKJRSS/p9s9AJrj2B5AqHgdE64e+Ut85vOfQt7r5zV0HgEQE RIjxB5AJIiA6PY2/1GMASERARBh/AJkiAqLR8/hLKQSARAREgPEHkAsiILhUxl9KKQAkIiAgxh9A roiAYFIbf6mL7wJYzNDY5AN8d0DuHmH8AeSN7w4IItXxl1K8AWjgJiA3j7ikfwfjDyAUbgJyk/r4 SxkEgEQE5IDxBxAFIiBzmYy/lFEASERAhhh/AFEhAjKT2fhLGQaARARkgPEHECUiIHWZjr+UcQBI RECKGH8AUSMCUpP5+Es5BIBEBKSA8QdgAhHQs1zGX8opACQioAeMPwBTiICu5Tb+Uo4BIBEBXWD8 AZhEBHQs1/GXcg4AiQjoAOMPwDQioG25j78UIAAkIqANjD+AQiAClhRk/KVAASARAS0w/gAKhQhY VLDxlwIGgEQENMH4AygkIuACQcdfChwAEhGwAOMPoNCIgLOCj78UQQBIRICkh1TzO4bGD34/9EEA IEtEgH7g5XYM7514MPRBUvvrgHsxNDb5QL1S2yrpaOizBHDQLzt1A+MPoAwGxyee9t5tkfzXQp8l gMfr0rYYxl+KJAAkacWeww+7vtp1kh4IfZb8uNG5H/fvHL7z68+GPgkA5GVo78QPZmvVGyTdFfos +fHfTHxl64q9k4+GPklDFI8AFjqxZcvK/uUn/85LW0KfJWOfqp6ovdMdPnwq9EEAIAR/89rlMy+u +pScfjn0WTLltffF5e6frb5z4oXQR1kougCQJD8y0jfdN/sh5/VhRXRLkZIXJfcH1b0TtzvJhz4M AITkJTezc9P7Jf9RSctCnydlXnJ3VE/M/36MX+xFGQAN0zs33Sj5T0l6aeizpORR5+q3VkcPfT30 QQAgJjM3brxWXp8tzIsDvZ51qv9Gdd+hO0MfZTFRf3U9tHfi7sRXrpX950Re0v+YrQ2uZ/wB4ELV uycPvajatXL6tOzfjn5Jdf/6mMdfivwGYKGZHRve4p37L5KuDH2WDn29Xq+/b8XYoQOhDwIAFszu uHZj3VXukPzG0GfphJO+U/f64PC+yd2hz9KOqG8AFqruO/jF6mzlau/0EUmzoc/Thh86ud+pbp28 lvEHgPYN7js0WV11+fVe/j2Sng99nqU4adp5fWhw2bGrrYy/ZOgGYKEXRta/xPVV3uu83itpdejz nOdJyf3n6uD8f3dfPGwhVAAgWv6m11dnagPvlPy/lnR56POc5znv9AnvdceKvZPRh8r5TAZAg7/p 9dXp2vLfcj55t5x/VdDDOE3I+zuqterfuPHx+aBnAYCC8evX989c3HernH+fpA2Bj/Ogl/vk0OD8 /7T8hZ7pAFhoavuGq1Vxt8jrHU56ZU7/2oe80996r8/E9MMdAKDI5nZcv6am+Vsl95s5fvH3tOQ+ V3favWJ0Yn9O/85MFSYAGvxtSma/smG9l7ZJ7gY5bZHXypT++H+U/D3e6V6pMj48ev9DKf25AIAu TG3fcLWSZMR5v01O25Tet40f887vd3LjrubuHRyb+FrRfnbL/wcZEGZqefOX8QAAAABJRU5ErkJg gg=="
                ></image>
                <g clipPath="url(#clipPath9424)" transform="translate(0 8)">
                    <path
                        fill="#4d4d4d"
                        fillOpacity="1"
                        fillRule="evenodd"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="5"
                        d="M-4385.268 940.028H-3185.268V1016.96H-4385.268z"
                        opacity="1"
                    ></path>
                    <g>
                        <path
                            fill="#d5f6ff"
                            d="M-3763.863 889.552h55.377v32.131h-55.377zm0 0"
                        ></path>
                        <path
                            fill="#aef"
                            d="M-3711.828 889.552h2.683v32.131h-2.683zm0 0"
                        ></path>
                        <path
                            fill="#bfbfbf"
                            d="M-3725.836 915.41h3.776v20.245h-3.776zm0 0"
                        ></path>
                        <rect
                            width="51.485"
                            height="4.876"
                            x="-3764.05"
                            y="919.123"
                            fill="#a02c2c"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            opacity="1"
                            ry="0.857"
                        ></rect>
                        <path
                            fill="#babac0"
                            d="M-3709.145 874.756h3.989v60.8h-3.989zm0 0"
                        ></path>
                        <path
                            fill="#bfbfbf"
                            d="M-3754.57 915.35h3.776v20.246h-3.776zm0 0"
                        ></path>
                        <path
                            fill="#acacac"
                            d="M-3752.682 915.35h1.888v20.246h-1.888zm0 0"
                        ></path>
                        <rect
                            width="45.859"
                            height="13.616"
                            x="-3761.159"
                            y="901.735"
                            fill="#a02c2c"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            opacity="1"
                            ry="2.392"
                        ></rect>
                        <path
                            fill="#acacac"
                            d="M-3723.948 915.41h1.888v20.245h-1.888zm0 0"
                        ></path>
                        <rect
                            width="48.824"
                            height="4.876"
                            x="-3764.05"
                            y="919.123"
                            fill="#c83737"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            opacity="1"
                            ry="0.857"
                        ></rect>
                        <path
                            fill="#a1a1a7"
                            d="M-3707.15 874.756h1.994v60.8h-1.995zm0 0"
                        ></path>
                        <path
                            fill="#fff"
                            fillRule="evenodd"
                            stroke="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeOpacity="1"
                            strokeWidth="0.802"
                            d="M-3752.838 901.726l8.442-12.194-1.939.062-8.38 12.132z"
                        ></path>
                        <path
                            fill="#fff"
                            fillRule="evenodd"
                            stroke="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeOpacity="1"
                            strokeWidth="0.802"
                            d="M-3763.12 908.7l14.129-19.2-3.002.063-11.087 15.216z"
                        ></path>
                        <rect
                            width="44.512"
                            height="13.616"
                            x="-3761.159"
                            y="901.735"
                            fill="#c83737"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            opacity="1"
                            ry="2.392"
                        ></rect>
                        <path
                            fill="#d5f6ff"
                            d="M-3822.616 889.524h55.377v32.13h-55.377zm0 0"
                            display="inline"
                        ></path>
                        <path
                            fill="#aef"
                            d="M-3770.58 889.524h2.683v32.13h-2.683zm0 0"
                            display="inline"
                        ></path>
                        <path
                            fill="#bfbfbf"
                            d="M-3780.271 915.38h3.776v20.246h-3.776zm0 0"
                            display="inline"
                        ></path>
                        <rect
                            width="51.485"
                            height="4.876"
                            x="-3818.485"
                            y="919.095"
                            fill="#a02c2c"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            display="inline"
                            opacity="1"
                            ry="0.857"
                        ></rect>
                        <path
                            fill="#babac0"
                            d="M-3825.927 874.727h3.988v60.8h-3.988zm0 0"
                            display="inline"
                        ></path>
                        <path
                            fill="#bfbfbf"
                            d="M-3809.005 915.322h3.776v20.246h-3.776zm0 0"
                            display="inline"
                        ></path>
                        <path
                            fill="#acacac"
                            d="M-3807.117 915.322h1.888v20.246h-1.888zm0 0"
                            display="inline"
                        ></path>
                        <rect
                            width="45.859"
                            height="13.616"
                            x="-3815.593"
                            y="901.707"
                            fill="#a02c2c"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            display="inline"
                            opacity="1"
                            ry="2.392"
                        ></rect>
                        <path
                            fill="#acacac"
                            d="M-3778.383 915.38h1.888v20.246h-1.888zm0 0"
                            display="inline"
                        ></path>
                        <rect
                            width="48.824"
                            height="4.876"
                            x="-3818.485"
                            y="919.095"
                            fill="#c83737"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            display="inline"
                            opacity="1"
                            ry="0.857"
                        ></rect>
                        <path
                            fill="#a1a1a7"
                            d="M-3823.933 874.727h1.994v60.8h-1.994zm0 0"
                            display="inline"
                        ></path>
                        <rect
                            width="65.675"
                            height="4.841"
                            x="-3827.665"
                            y="870.567"
                            fill="#d38d5f"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            display="inline"
                            opacity="1"
                            ry="0.858"
                        ></rect>
                        <rect
                            width="65.675"
                            height="4.841"
                            x="-3768.912"
                            y="870.595"
                            fill="#d38d5f"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            opacity="1"
                            ry="0.858"
                        ></rect>
                        <rect
                            width="65.675"
                            height="3.922"
                            x="-3768.912"
                            y="871.924"
                            fill="#a05a2c"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            opacity="1"
                            ry="0.695"
                        ></rect>
                        <rect
                            width="65.675"
                            height="3.922"
                            x="-3827.665"
                            y="871.896"
                            fill="#a05a2c"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            display="inline"
                            opacity="1"
                            ry="0.695"
                        ></rect>
                        <path
                            fill="#fff"
                            fillRule="evenodd"
                            stroke="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeOpacity="1"
                            strokeWidth="0.802"
                            d="M-3811.59 901.698l8.441-12.195-1.938.063-8.38 12.132z"
                            display="inline"
                        ></path>
                        <path
                            fill="#fff"
                            fillRule="evenodd"
                            stroke="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeOpacity="1"
                            strokeWidth="0.802"
                            d="M-3821.872 908.672l14.128-19.2-3.001.062-11.087 15.217z"
                            display="inline"
                        ></path>
                        <rect
                            width="44.512"
                            height="13.616"
                            x="-3815.593"
                            y="901.707"
                            fill="#c83737"
                            fillOpacity="1"
                            fillRule="evenodd"
                            stroke="none"
                            strokeDasharray="2.311, 4.622"
                            strokeDashoffset="0"
                            strokeLinecap="square"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="2.311"
                            display="inline"
                            opacity="1"
                            ry="2.392"
                        ></rect>
                        <g transform="translate(1543.778 -359.94) scale(1.35295)">
                            <path
                                fill="#babac0"
                                d="M-3987.216 922.99h2.947v34.311h-2.947zm0 0"
                                display="inline"
                            ></path>
                            <path
                                fill="#a1a1a7"
                                d="M-3985.742 922.99h1.474v34.311h-1.474zm0 0"
                                display="inline"
                            ></path>
                            <rect
                                width="13.014"
                                height="8.955"
                                x="-3996.37"
                                y="914.846"
                                fill="#2c5aa0"
                                fillOpacity="1"
                                fillRule="evenodd"
                                stroke="none"
                                strokeDasharray="2.311, 4.622"
                                strokeDashoffset="0"
                                strokeLinecap="square"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="2.311"
                                display="inline"
                                opacity="1"
                                ry="1.573"
                            ></rect>
                            <rect
                                width="13.262"
                                height="8.955"
                                x="-3998.617"
                                y="914.846"
                                fill="#3771c8"
                                fillOpacity="1"
                                fillRule="evenodd"
                                stroke="none"
                                strokeDasharray="2.311, 4.622"
                                strokeDashoffset="0"
                                strokeLinecap="square"
                                strokeLinejoin="miter"
                                strokeMiterlimit="10"
                                strokeOpacity="1"
                                strokeWidth="2.311"
                                display="inline"
                                opacity="1"
                                ry="1.573"
                            ></rect>
                        </g>
                    </g>
                    <rect
                        width="1200"
                        height="5.671"
                        x="-4385.268"
                        y="980.915"
                        fill="url(#pattern13992)"
                        fillOpacity="1"
                        fillRule="evenodd"
                        stroke="none"
                        strokeDasharray="none"
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="5"
                        opacity="0.75"
                        ry="1.32"
                    ></rect>
                    <g
                        fillRule="evenodd"
                        strokeOpacity="1"
                        display="inline"
                        transform="translate(-3639.586 895.288) scale(.22085)"
                    >
                        <path
                            fill="#b4c0c9"
                            fillOpacity="1"
                            stroke="none"
                            strokeDasharray="none"
                            strokeDashoffset="0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="4"
                            strokeWidth="3.75"
                            d="M88.232 264.035a45.735 31.793 0 00-45.398 28.123h-.797v35.25h41.129a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zm463.575 0a45.735 31.793 0 00-45.399 28.123h-.797v35.25h41.13a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zM92.87 88.746H750.96c17.448 0 31.496 14.048 31.496 31.496v175.535c0 17.448-14.048 31.494-31.496 31.494H108.141l-.006.348H-74.197l-40.518-6.873.795-74.57 43.695-112.371 1.174-.19C-24.05 92.054 67.522 87.988 90.684 88.844l-.01.265a6.857 6.857 0 012.197-.363z"
                            display="inline"
                            opacity="1"
                        ></path>
                        <path
                            fill="#000"
                            fillOpacity="1"
                            stroke="none"
                            strokeDasharray="none"
                            strokeDashoffset="0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="4"
                            strokeWidth="3.75"
                            d="M127.792 308.897a39.41 39.41 0 01-39.41 39.41 39.41 39.41 0 01-39.41-39.41 39.41 39.41 0 0139.41-39.41 39.41 39.41 0 0139.41 39.41z"
                            display="inline"
                            opacity="1"
                        ></path>
                        <path
                            fill="#333"
                            fillOpacity="0.996"
                            stroke="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeWidth="1"
                            d="M-71.575 159.83v82.227h-31.953z"
                            display="inline"
                        ></path>
                        <path
                            fill="#e90020"
                            fillOpacity="1"
                            stroke="none"
                            strokeDasharray="none"
                            strokeDashoffset="0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="4"
                            strokeWidth="3.75"
                            d="M88.232 500.035a45.735 31.793 0 00-45.398 28.123h-.797v35.25h41.129a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zm463.575 0a45.735 31.793 0 00-45.399 28.123h-.797v35.25h41.13a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zM92.87 324.746H750.96c17.448 0 31.496 14.048 31.496 31.496v175.535c0 17.448-14.048 31.494-31.496 31.494H108.141l-.006.348H-74.197l-40.518-6.873.795-74.57 43.695-112.371 1.174-.19c45.001-41.561 136.573-45.627 159.735-44.771l-.01.265a6.857 6.857 0 012.197-.363z"
                            clipPath="url(#clipPath4632-6-5-3-3-36)"
                            display="inline"
                            opacity="1"
                            transform="translate(0 -236)"
                        ></path>
                        <path
                            fill="#000"
                            fillOpacity="1"
                            stroke="none"
                            strokeDasharray="none"
                            strokeDashoffset="0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="4"
                            strokeWidth="3.75"
                            d="M591.217 308.897a39.41 39.41 0 01-39.41 39.41 39.41 39.41 0 01-39.41-39.41 39.41 39.41 0 0139.41-39.41 39.41 39.41 0 0139.41 39.41z"
                            display="inline"
                            opacity="1"
                        ></path>
                        <path
                            fill="#0049a8"
                            fillOpacity="1"
                            stroke="none"
                            strokeDasharray="none"
                            strokeDashoffset="0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="4"
                            strokeWidth="3.75"
                            d="M88.232 500.035a45.735 31.793 0 00-45.398 28.123h-.797v35.25h41.129a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zm463.575 0a45.735 31.793 0 00-45.399 28.123h-.797v35.25h41.13a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zM92.87 324.746H750.96c17.448 0 31.496 14.048 31.496 31.496v175.535c0 17.448-14.048 31.494-31.496 31.494H108.141l-.006.348H-74.197l-40.518-6.873.795-74.57 43.695-112.371 1.174-.19c45.001-41.561 136.573-45.627 159.735-44.771l-.01.265a6.857 6.857 0 012.197-.363z"
                            clipPath="url(#clipPath4684-78-8-4-8-35)"
                            display="inline"
                            opacity="1"
                            transform="translate(-.03 -235.711)"
                        ></path>
                        <path
                            fill="#333"
                            fillOpacity="1"
                            stroke="none"
                            strokeDasharray="none"
                            strokeDashoffset="0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="4"
                            strokeWidth="3.75"
                            d="M-60.417 151.432H689.583V242.057H-60.417z"
                            display="inline"
                            opacity="1"
                        ></path>
                        <path
                            fill="#999"
                            fillOpacity="1"
                            stroke="none"
                            strokeDasharray="none"
                            strokeDashoffset="0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="4"
                            strokeWidth="3.75"
                            d="M113.431 308.897a25.05 25.05 0 01-25.05 25.05 25.05 25.05 0 01-25.048-25.05 25.05 25.05 0 0125.049-25.05 25.05 25.05 0 0125.05 25.05z"
                            display="inline"
                            opacity="1"
                        ></path>
                        <path
                            fill="#999"
                            fillOpacity="1"
                            stroke="none"
                            strokeDasharray="none"
                            strokeDashoffset="0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="4"
                            strokeWidth="3.75"
                            d="M576.856 308.897a25.05 25.05 0 01-25.049 25.05 25.05 25.05 0 01-25.049-25.05 25.05 25.05 0 0125.05-25.05 25.05 25.05 0 0125.048 25.05z"
                            display="inline"
                            opacity="1"
                        ></path>
                        <path
                            fill="#000"
                            fillOpacity="0.258"
                            stroke="none"
                            strokeDasharray="none"
                            strokeDashoffset="0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="4"
                            strokeWidth="3.75"
                            d="M88.232 264.035a45.735 31.793 0 00-45.398 28.123h-.797v35.25h41.129a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zm463.575 0a45.735 31.793 0 00-45.399 28.123h-.797v35.25h41.13a45.735 31.793 0 005.066.211 45.735 31.793 0 004.81-.21h41.067v-35.25h-.504a45.735 31.793 0 00-45.373-28.124zM92.87 88.746H750.96c17.448 0 31.496 14.048 31.496 31.496v175.535c0 17.448-14.048 31.494-31.496 31.494H108.141l-.006.348H-74.197l-40.518-6.873.795-74.57 43.695-112.371 1.174-.19C-24.05 92.054 67.522 87.988 90.684 88.844l-.01.265a6.857 6.857 0 012.197-.363z"
                            clipPath="url(#clipPath6110-2-5-1-3-91)"
                            display="inline"
                            opacity="1"
                        ></path>
                        <path
                            fill="#000"
                            fillOpacity="0.996"
                            stroke="#b1b1b1"
                            strokeDasharray="none"
                            strokeDashoffset="0"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeMiterlimit="4"
                            strokeWidth="9.056"
                            d="M652.294 251.225H743.12V309.941H652.294z"
                            opacity="1"
                        ></path>
                        <path
                            fill="none"
                            stroke="#b1b1b1"
                            strokeDasharray="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeMiterlimit="4"
                            strokeWidth="9.056"
                            d="M652.423 308.86l90.223-56.954z"
                        ></path>
                        <path
                            fill="none"
                            stroke="#b1b1b1"
                            strokeDasharray="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeMiterlimit="4"
                            strokeWidth="9.056"
                            d="M742.818 309.059l-90.223-56.953z"
                            display="inline"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
